<template>
    <page :tabs="tabs">
        <grid ref="grid" :column-defs="columnDefs" :row-data="properties" :is-auto-height="false"></grid>
    </page>
</template>

<script>
import API from '../../../api';
import { UNLAYER_TEMPLATE_BY_ID_ENDPOINT } from '../../../endpoints';
import Page from '../../generic/page/page.vue';

import { escapeHTML } from '../../../utils/strings';
import Grid from '../../generic/grid/grid.vue';

const DEFAULT_AGREEMENT_NAME = 'Default';

export default {
    name: 'DocumentAgreements',
    components: {
        Grid,
        Page,
    },
    computed: {
        agreementOptions() {
            return [
                { value: null, text: DEFAULT_AGREEMENT_NAME },
                ...this.agreements.map((agreement) => ({
                    value: agreement.id,
                    text: agreement.name,
                })),
            ];
        },
        tabs() {
            return [
                {
                    title: 'Settings',
                    route: '/app/digital-signature/setup/',
                    active: false,
                },
                {
                    title: 'Requested Signatures',
                    route: '/app/digital-signature/list/',
                    active: false,
                },
                {
                    title: 'Pending Signatures',
                    route: '/app/digital-signature/pending/',
                    active: false,
                },
                {
                    title: 'Assignments',
                    route: '/app/digital-signature/assignments/',
                    active: true,
                },
            ];
        },
    },
    data() {
        return {
            agreements: [],
            agreementsByID: {},
            properties: [],
            columnDefs: [
                {
                    field: 'id',
                    type: 'idColumn',
                    maxWidth: 110,
                    sort: 'asc',
                },
                {
                    field: 'name',
                    headerName: 'Property Name',
                },
                {
                    headerName: 'Rental Agreement',
                    cellEditor: 'selectCellEditor',
                    editable: true,
                    cellClass: 'text-primary lx-editable-cell',
                    cellEditorParams: ({ data }) => ({
                        options: this.agreementOptions,
                    }),
                    valueGetter: ({ data }) => data.unlayer_agreement,
                    getQuickFilterText: ({ data }) => this.getAgreementNameByID(data.unlayer_agreement),
                    cellRenderer: ({ data }) => escapeHTML(this.getAgreementNameByID(data.unlayer_agreement)),
                    valueSetter: async ({ node, data, newValue, oldValue }) => {
                        (async () => {
                            try {
                                await API.post(
                                    UNLAYER_TEMPLATE_BY_ID_ENDPOINT(newValue || '0') + 'assign-agreement-to-property/',
                                    {
                                        property_id: data.id,
                                    }
                                );
                                data.unlayer_agreement = newValue;
                                node.setData(data);
                            } catch {
                                this.errorToast({ text: 'Could not save agreement.' });
                                data.unlayer_agreement = oldValue;
                                node.setData(data);
                            }
                        })();
                        data.agreement_id = newValue;
                        return true;
                    },
                },
            ],
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            this.$parent.$emit('busy', true);

            try {
                await Promise.all([this.fetchAgreements(), this.fetchProperties()]);
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
        async fetchAgreements() {
            try {
                const response = await API.get(UNLAYER_TEMPLATE_BY_ID_ENDPOINT() + 'agreements/');
                this.agreements = response.data;
                this.agreementsByID = response.data.reduce(
                    (agreementsByID, agreement) => ({
                        ...agreementsByID,
                        [agreement.id]: agreement,
                    }),
                    {}
                );
            } catch {
                this.errorToast({ text: 'Could not load agreements.' });
            }
        },
        async fetchProperties() {
            try {
                const response = await API.get(UNLAYER_TEMPLATE_BY_ID_ENDPOINT() + 'agreement-properties/');
                this.properties = response.data;
            } catch {
                this.errorToast({ text: 'Could not load properties.' });
            }
        },
        getAgreementNameByID(id) {
            if (id && this.agreementsByID[id]) {
                return this.agreementsByID[id].name;
            }
            return DEFAULT_AGREEMENT_NAME;
        },
    },
};
</script>
